export default "__VITE_ASSET__RViX4VBj__"